/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersRecruitersQueryResponse, GetUsersRecruiters400 } from '../entities/GetUsersRecruiters'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetUsersRecruitersUrl() {
  return `/users/recruiters` as const
}

/**
 * @description Получение вербовщиков
 * @summary Получение вербовщиков
 * {@link /users/recruiters}
 */
export async function getUsersRecruiters(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetUsersRecruitersQueryResponse, ResponseErrorConfig<GetUsersRecruiters400>, unknown>({
    method: 'GET',
    url: getGetUsersRecruitersUrl().toString(),
    ...requestConfig,
  })
  return res.data
}